import { useEffect, useState } from "react";
import TitlePage from "../../../components/TitlePage";
import { Row, Col, Button, FormLabel, FormControl } from "react-bootstrap";
import ResponsiveDataTable from "../../../components/DataTable";
import { CelBreak, CelBreak25, NormalFont } from "../../../components/GridCell/styles";
import { converteDataProtheus, ErroMsg, formatarComoDecimal, formatarMoeda2, RetornaUsuarioLogado, SucessoMsg } from "../../../contents/VariaveisGlobais";
import { handleData, handlePrecoUnitario, handleValorTotal } from "../../../components/GridCell/Preco";
import { ConsultaAPI_URLQuery } from "../../../../backend/ConsultaAPI";
import LoadingSpinner from "../../../components/LoadinSpinner";
import InputGeral from "../../../components/InputGeral/Index";
import { usePopUp } from "../../../components/BootBox";
import { ConsumoAPI_POST } from "../../../../backend/ConsumoAPI";
import { format } from "date-fns";
import { toast } from "react-toastify";

function ListaConfereNotaFiscal(){
    const [carregar, setCarregar] = useState(false);
    const [data, setData]   = useState([]);
    const { DisparaBootBox, FechaBootBox  } = usePopUp();
    const usuarioLogado = RetornaUsuarioLogado()
    const CCFiltro = usuarioLogado.filtraParametroEmpresasCentroCusto.centroCusto.map(item => item.trim()).join(',') || '*'

    var campoMotivo = "";

    const columnsItens = [
        {
            Header: "Item",
            accessor: "nitem",
            Cell: (item) => {
                return String(item.value).padStart(4,"0")
            }
        },
        {
            Header: "Produto",
            accessor: "description",
            Cell: (item) => {
                const {description, service_description, erp_cost_center} = item.row.original
                const descricao = description?.trim() || service_description

                return (
                    <>
                        <NormalFont>{descricao}</NormalFont>
                        { erp_cost_center && <><br/><NormalFont><strong>Centro Custo: </strong>{erp_cost_center?.trim()}</NormalFont></>}
                    </>
                )
            }
        },
        {
            Header: "UM",
            accessor: "unit",
        },
        {
            Header: "Qtd",
            accessor: "quantity",
            Cell: (item) => {
                return formatarComoDecimal(item.value, 4)
            }
        },
        {
            Header: "Preço Unitário",
            accessor: "unit_price",
            Cell: handlePrecoUnitario
        },
        {
            Header: "Valor Total",
            accessor: "total_value",
            Cell: handleValorTotal
        },
    ]

    const columns = [
        {
            Header: "Empresa",
            accessor: "customer_legal_name",
            Cell: (item) => {
                const {customer_legal_name, customer_identification_number, supplier_legal_name, supplier_identification_number, access_key} = item.row.original
                return (
                    <>
                        <p><strong>Empresa: </strong>{customer_legal_name?.trim()} - ({customer_identification_number?.trim()})</p>
                        <p><strong>Fornecedor: </strong>{supplier_legal_name?.trim()} - ({supplier_identification_number?.trim()})</p>
                        <p><strong>Chave Acesso: </strong>{access_key?.trim()}</p>
                    </>
                )
            }
        },
        {
            Header: "NF",
            accessor: "number",
            Cell: (item) => {
            const {number, series, model_type} = item.row.original
            return (
                <>
                    <p><strong>NF: </strong>{String(number).padStart(9,"0")}</p>
                    <p><strong>Serie: </strong>{series}</p>
                    <p><strong>Tipo: </strong>{model_type}</p>
                </>
            )
            }
        },
        {
            Header: "Emissão",
            accessor: "issue_date",
            Cell: handleData
        },
        {
            Header: 'Total NF',
            accessor: "total_value",
            Cell: handleValorTotal
        }
    ]

    const listaCNF = async() => {
        setCarregar(true);
        
        const retConsulta = await ConsultaAPI_URLQuery('v360', CCFiltro)

        if (retConsulta?.data.length > 0){
            setData(retConsulta.data);
        }
        setCarregar(false);
    }

    useEffect( () => {
        listaCNF()
    },[])    
    
    const handleVisualizar = (row) => {
        const { service_description, customer_legal_name, customer_identification_number, supplier_legal_name, supplier_identification_number, number, series, issue_date, model_type, total_value, invoice_items } = row.original
        const dEmissao = converteDataProtheus(issue_date.replaceAll('-',''))
        const nTotalNF = formatarMoeda2(total_value, 2)
        const invoiceItemsAtualizados = invoice_items?.map(item => ({
            ...item,
            service_description
        }))

        const Mensagem = <>        
            <Row>
                <Col md="4">
                    <InputGeral
                        tipo={"text"}
                        label={"Empresa"}
                        value={customer_legal_name?.trim() + " (" + customer_identification_number?.trim() + ")"}
                        disabled={true}
                    />
                </Col>
                <Col md="2">
                    <InputGeral
                        tipo={"text"}
                        label={"NF"}
                        value={String(number).padStart(9,"0")}
                        disabled={true}
                    />
                </Col>
                <Col md="2">
                    <InputGeral
                        tipo={"text"}
                        label={"Serie"}
                        value={series}
                        disabled={true}
                    />
                </Col>
                <Col md="2">
                    <InputGeral
                        tipo={"text"}
                        label={"Tipo"}
                        value={model_type}
                        disabled={true}
                    />
                </Col>
                <Col md="2">
                    <InputGeral
                        tipo={"date"}
                        label={"Emissão"}
                        value={dEmissao}
                        disabled={true}
                    />
                </Col>
                <Col md="9">
                    <InputGeral
                        tipo={"text"}
                        label={"Fornecedor"}
                        value={supplier_legal_name?.trim() + " (" + supplier_identification_number?.trim() + ")"}
                        disabled={true}
                    />
                </Col>                         
                <Col md="3">
                    <InputGeral
                        tipo={"monetario"}
                        label={"Total NF"}
                        valueNoUpdate={nTotalNF}
                        disabled={true}
                    />
                </Col>                         
            </Row>
            <Row>
                <Col md="12">
                    <ResponsiveDataTable
                        columns={columnsItens} 
                        data={invoiceItemsAtualizados} 
                        buttons={[]}
                        habilitaBuscar={false}
                    />
                </Col>
            </Row>
        </>

        // Renderiza o componente diretamente no BootBox
        DisparaBootBox(
            `Nota Fiscal`,
            () => Mensagem,
            [
                { variant: 'light', action: FechaBootBox, label: '↩ Fechar' }
            ],
            null,
            false,
            'xl',
            true,
            true // withComponent = true
        );
    }

    const formatDateISO = (date = new Date()) => {
        const formatted = format(date, "yyyy-MM-dd'T'HH:mm:ss.SSS");

        const offset = -date.getTimezoneOffset();
        const sign = offset >= 0 ? '+' : '-';

        const pad = (n) => String(Math.floor(Math.abs(n))).padStart(2, '0');

        const hours = pad(offset / 60);
        const minutes = pad(offset % 60);

        return `${formatted}${sign}${hours}:${minutes}`;
    };
    
    const handleAprovar = async () => {
        setCarregar(true)
        const dataEnvio = data.filter((item) => item.Check === true);

        let lSucesso = false;
        let lFalha = false;

        const nfSucesso = [];
        const nfFalha = [];

        for (const item of dataEnvio) {
            const valueJSON = {
                id: item.id,
                numero: item.number,
                serie: item.series,
                datahora: formatDateISO(),
                usuario: usuarioLogado.nome,
                erroMensagem: ""
            };

            try {
                const oRetorno = await ConsumoAPI_POST('V360/sucesso', valueJSON);

                const componente = (
                    <div key={item.id}>
                        <p>Empresa: {item.customer_legal_name}</p>
                        <p>Fornecedor: {item.supplier_legal_name}</p>
                        <p>NF: {item.series}/{item.number}</p>
                    </div>
                );

                if (oRetorno?.data) {
                    lSucesso = true;
                    nfSucesso.push(componente);
                } else {
                    lFalha = true;
                    nfFalha.push(componente);
                }

            } catch (error) {
                lFalha = true;

                nfFalha.push(
                    <div key={item.id}>
                        <p>Empresa: {item.customer_legal_name}</p>
                        <p>Fornecedor: {item.supplier_legal_name}</p>
                        <p>NF: {item.series}/{item.number}</p>
                    </div>
                );
            }
        }

        setCarregar(false)

        if (lSucesso) {
            SucessoMsg(
                <>
                    <h4>Sucesso na Integração</h4>
                    {nfSucesso}
                </>
            );
        }

        if (lFalha) {
            ErroMsg(
                <>
                    <h4>Falha na Integração</h4>
                    {nfFalha}
                </>
            );
        }

        listaCNF()
    };
    
    const handleReprovar = () => {
        const dataEnvio = data.filter((item) => item.Check === true);

        if (dataEnvio.length > 0){
            const Mensagem = ( <>
                    <FormLabel>Motivo Reprovação</FormLabel>
                    <FormControl
                        type='text'
                        onChange={handleCampoMotivo}
                    />
                </>
            )
            
            const buttonsRender = [
                { variant: 'primary', action: handleConfirmaReprovar, label: '✓ Confirmar' },
                { variant: 'secondary', action: FechaBootBox, label: '✗ Cancelar' }
            ]
            
            campoMotivo = ''

            DisparaBootBox('Confirma Reprovação dos Itens Selecionados ?', Mensagem, buttonsRender, 0, null)
        }        
    }

    const handleCampoMotivo = (e) =>{
        campoMotivo = e.target.value
    }

    const handleConfirmaReprovar = async() => {
        if (!campoMotivo){
            toast.warning('O prenchimento do Motivo da Rejeição é obrigatório.');
            return
        }

        FechaBootBox()
        setCarregar(true)

        const dataEnvio = data.filter((item) => item.Check === true);

        let lSucesso = false;
        let lFalha = false;

        const nfSucesso = [];
        const nfFalha = [];

        for (const item of dataEnvio) {
            const valueJSON = {
                id: item.id,
                numero: item.number,
                serie: item.series,
                datahora: formatDateISO(),
                erroMensagem: campoMotivo,
                usuario: usuarioLogado.nome                
            };

            try {
                const oRetorno = await ConsumoAPI_POST('V360/erro', valueJSON);

                const componente = (
                    <div key={item.id}>
                        <p>Empresa: {item.customer_legal_name}</p>
                        <p>Fornecedor: {item.supplier_legal_name}</p>
                        <p>NF: {item.series}/{item.number}</p>
                    </div>
                );

                if (oRetorno?.data) {
                    lSucesso = true;
                    nfSucesso.push(componente);
                } else {
                    lFalha = true;
                    nfFalha.push(componente);
                }

            } catch (error) {
                lFalha = true;

                nfFalha.push(
                    <div key={item.id}>
                        <p>Empresa: {item.customer_legal_name}</p>
                        <p>Fornecedor: {item.supplier_legal_name}</p>
                        <p>NF: {item.series}/{item.number}</p>
                    </div>
                );
            }
        }

        setCarregar(false)

        if (lSucesso) {
            SucessoMsg(
                <>
                    <h4>Sucesso na Integração</h4>
                    {nfSucesso}
                </>
            );
        }

        if (lFalha) {
            ErroMsg(
                <>
                    <h4>Falha na Integração</h4>
                    {nfFalha}
                </>
            );
        }

        listaCNF()
    }

    return (
        <>
            <Row>
                <LoadingSpinner isLoading={carregar}/>
                <Col md="12" xs="12">
                    <TitlePage 
                        text="Confere Nota Fiscal"
                        exibirIncluir={false}                        
                    />
                </Col>          
            </Row>
            <Row>
                <Col md="3"></Col>
                <Col md="2">
                    <Button className="w-100" variant='success' onClick={handleAprovar}>Aprovar Selecionados</Button>
                </Col>
                <Col md="2">
                    <Button className="w-100" variant='danger' onClick={handleReprovar}>Reprovar Selecionados</Button>
                </Col>
                <Col md="2">
                    <Button className="w-100" variant='light' onClick={listaCNF}>Buscar Dados</Button>
                </Col>
                <Col md="3"></Col>
            </Row>
            <Row>
                <Col md="12" xs="12">
                    <ResponsiveDataTable 
                        columns={columns} 
                        data={data} 
                        buttons={[
                            {isVisual: true, action: handleVisualizar, label: "Visualizar Itens", icone: "MdOutlinePreview", style: "light"}, 
                        ]}
                        habilitaCheckBox={true}
                        habilitaBuscar={true}                        
                    />
                </Col>
            </Row>
        </>
    );
}

export default ListaConfereNotaFiscal;